import React from 'react'

import StorfoxLocationStatusField, { OPTIONS as BASE_OPTIONS } from '~/components/Fields/LocationStatusField'

const OPTIONS = [{ value: '', name: 'All' }, ...BASE_OPTIONS]

function LocationStatusField (props) {
  return (
    <StorfoxLocationStatusField
      name="status"
      label="Status"
      options={OPTIONS}
      {...props}
    />
  )
}

export default LocationStatusField
